import type { RootStore } from '~/stores/root.store';

export class WorkspaceController {
    rootStore: RootStore;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;
    }

    async fetchWorkspace(workspaceId: string) {
        const { workspaceStore, workspaceService } = this.rootStore;

        const workspace = await workspaceService.fetchWorkspace(workspaceId);
        const workspaceInstance = workspaceStore.load(workspace);

        return workspaceInstance;
    }
}
